export class ContractedInvoice {
    subtotal:number = 0;
    iva:number = 0; 
    retencion:number = 0; 
    total:number = 0; 
    invoice:string = ''; 
    description:string = ''; 
    travel_id:number = 0;
    customer_type:string = '';
    retencion_isr:number = 0;
    retencion_isr_is:boolean = false;

    ncre:string = '';
    ncre_is:boolean = false;
    ncre_subtotal:number = 0;
    ncre_iva:number = 0;
    ncre_retencion:number = 0;
    ncre_retencion_isr:number = 0;
    ncre_retencion_isr_is:boolean = false;
    ncre_total:number = 0;
    ncre_description:string = '';

    ncar:string = '';
    ncar_is:boolean = false;
    ncar_subtotal:number = 0;
    ncar_iva:number = 0;
    ncar_retencion:number = 0;
    ncar_retencion_isr:number = 0;
    ncar_retencion_isr_is:boolean = false;
    ncar_total:number = 0;
    ncar_description:string = '';
    
    inplug:string = '';
    inplug_is:boolean = false;
    inplug_subtotal:number = 0;
    inplug_iva:number = 0;
    inplug_retencion:number = 0;
    inplug_retencion_isr:number = 0;
    inplug_retencion_isr_is:boolean = false;
    inplug_total:number = 0;
    inplug_description:string = '';
}
